import { useState } from 'react';
import type { TypedClient } from '@platform/openapi';
import type { Order } from './orders.ts';
import type { OrderActionKey } from './useAvailableOrderActions.ts';
import { useOrderActions } from './useOrderActions.ts';

export const useOrderMoves = (api: TypedClient, onEdit: (orderId: string) => void) => {
  const actions = useOrderActions(api);
  const [canceling, setCanceling] = useState<Order | null>(null);
  const [dispatching, setDispatching] = useState<Order | null>(null);

  const run = (key: OrderActionKey, order: Order) => {
    if (key === 'confirm' || key === 'reopen') {
      actions.mutate({ kind: key, order });
      return;
    }
    if (key === 'edit') {
      onEdit(order.id);
      return;
    }
    actions.reset();
    if (key === 'cancel') setCanceling(order);
    else setDispatching(order);
  };

  return { actions, canceling, dispatching, setCanceling, setDispatching, run };
};

export type OrderMoves = ReturnType<typeof useOrderMoves>;
